<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon> Bloqueo Modulo Activo</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Sistema</span>
      <span> /</span>
      <span>Bloqueo Modulo Activo</span>
    </p>
  </div>
</div>

<div class="container-fluid mt-3">
    <div class="card mb-3">
        <div class="card-body">
            <!-- Panel de Filtros -->
            <form [formGroup]="formFiltro" class="mb-4">
                <div class="row">
                    <div class="col-md-5">
                        <div class="md-form">
                            <mdb-select formControlName="codigoModulo" label="Modulos" [options]="optionModulos"
                              placeholder="Modulos"></mdb-select>
                          </div>
                    </div>
                    <div class="col-md-5">
                        <div class="md-form">
                            <mdb-select formControlName="rutUsuario" label="Usuarios" [options]="optionUsuarios"
                              placeholder="Usuarios"></mdb-select>
                          </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer d-flex align-items-end" style="border-top: 1px solid #dee2e6">
            <button mdbBtn type="button" color="grey" size="sm" mdbWavesEffect (click)="limpiarFiltros()">Limpiar</button>
            <button mdbBtn type="button" color="grey" size="sm" mdbWavesEffect (click)="buscar()">Buscar</button>
        </div>
    </div>
    <div class="card">
        <div class="card-body">
            <!-- Tabla de Bloqueos -->
            <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col">Nombre Módulo</th>
                            <th scope="col">RUT Usuario</th>
                            <th scope="col">Nombre Usuario</th>
                            <th scope="col">Última Actividad</th>
                            <th scope="col">Fecha Expiración</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="bloqueos.length === 0">
                            <td colspan="7" class="text-center">No hay bloqueos que coincidan con los filtros o no hay bloqueos activos.</td>
                        </tr>
                        <tr *ngFor="let bloqueo of bloqueos">
                            <td>{{ bloqueo.nombreModulo }}</td>
                            <td>{{ bloqueo.rutFormato }}</td>
                            <td>{{ bloqueo.nombreUsuario || 'N/A' }}</td>
                            <td>{{ bloqueo.fecha_ultima_actividad | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                            <td>{{ bloqueo.fecha_expiracion | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                            <td>
                                <button mdbBtn type="button" color="danger" size="sm" mdbWavesEffect (click)="validarEliminar(bloqueo)">
                                    <mdb-icon fas icon="trash-alt" class="mr-1"></mdb-icon> Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
